import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { loadPins } from "@/lib/offline";

// Clickjacking guard: refuse to run inside a frame unless the embedding page is the Emergent preview shell.
if (window.top !== window.self) {
  const ref = (() => { try { return new URL(document.referrer).hostname; } catch { return ""; } })();
  const trusted = /(^|\.)(emergent\.sh|emergentagent\.com|emergent\.host)$/.test(ref);
  if (!trusted) window.top.location.replace(window.location.href);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
loadPins();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
